import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getDbInfo() {
    return axios.get(`${baseUrl}/dashboard/sql/get-dbinfo.do`);
  },
  addDbInfo(dbInfo) {
    return axios.post(`${baseUrl}/dashboard/sql/add-dbinfo.do`, dbInfo);
  },
  updateDbInfo(dbInfo) {
    return axios.post(`${baseUrl}/dashboard/sql/update-dbinfo.do`, dbInfo);
  },
  deleteDbInfo(dbId) {
    return axios.get(`${baseUrl}/dashboard/sql/delete-dbinfo.do`, {
      params: {
        dbId,
      },
    });
  },
  getQueryInfo() {
    return axios.get(`${baseUrl}/dashboard/sql/get-queryinfo.do`);
  },
  addQueryInfo(queryInfo) {
    return axios.post(`${baseUrl}/dashboard/sql/add-queryinfo.do`, queryInfo);
  },
  updateQueryInfo(queryInfo) {
    return axios.post(`${baseUrl}/dashboard/sql/update-queryinfo.do`, queryInfo);
  },
  deleteQueryInfo(queryId) {
    return axios.get(`${baseUrl}/dashboard/sql/delete-queryinfo.do`, {
      params: {
        queryId,
      },
    });
  },
  getDbtypeInfo() {
    return axios.get(`${baseUrl}/dashboard/sql/get-dbtype-info.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/dashboard/sql.js